import $ from 'jquery'
import {Core} from "./core.js";

function handleReadyDocument() {
  if (Core.isAdmin()) {
    return
  }
  let $scripts = $('[data-src]')
  $scripts.each(activeScript)
}

function activeScript() {
  let $script = $(this)

  $script.attr('src', $script.data('src'))
}

$(handleReadyDocument)
